import { objectValues } from "@ea/shared_components/utils/object";

import * as virtualUsersActions from "./virtualUsers.actions";
import virtualUsersEpicsMap from "./virtualUsers.epics";
import * as virtualUsersReducers from "./virtualUsers.reducers";

const virtualUsersEpics = objectValues(virtualUsersEpicsMap);

export { virtualUsersActions, virtualUsersReducers, virtualUsersEpics };
